import {DropDownFieldDefinition} from '../../fields-definitions/drop-down-field-definition';
import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import {makeConfigurationArea} from '../make-configuration-area';
import {TextFieldDefinition} from '../../fields-definitions/text-field-definition';
import {ROOT_CONFIGURATION_KEYS} from '../../root-configuration-keys';
import {BooleanFieldDefinition} from "../../fields-definitions/boolean-field-definition";

const GRS_APPROVAL_STATES = [
    {value: 'APPROVED'},
    {value: 'LATEST'},
    {value: 'PRODUCTION'}
];

export function makeGamesSettingsArea(services: ILauncherServiceFactory) {
    return makeConfigurationArea(ROOT_CONFIGURATION_KEYS.sdk, services, {
        Game: {
            ChillEnvironment: new DropDownFieldDefinition('GGP environment', 'This property sets the GGP server where the Chill connects to',
                [
                    {value: 'Mirage_88_89'},
                    {value: 'Mirage_90'},
                    {value: 'Mirage_50'},
                    {value: 'PT_production'},
                    {value: 'Mirage_94'},
                    {value: 'Mirage_49'},
                    {value: 'Mirage_53'},
                    {value: 'Mirage_54'},
                    {value: 'Mirage_210'},
                    {value: 'Mirage_239'},
                    {value: 'USQA_143'},
                    {value: 'USQA_128'},
                    {value: 'MGM_164_165'},
                    {value: 'Europe_production'},
                    {value: 'Production_8081'},
                    {value: 'USA_production'},
                    {value: 'nj_clone'},
                    {value: 'NJ_physical'},
                    {value: 'Certification'},
                    {value: 'Dublin'},
                    {value: 'PT_Dublin'},
                    {value: 'NJ_physical_Stage'},
                    {value: 'Local GGP'}
                ]),
            GRS: {
                GRSEnvironment: new DropDownFieldDefinition('GRS Environment', '', [
                    {value: 'Mirage'},
                    {value: 'Stage_dublin'},
                    {value: 'Production_dublin'}
                ]),
                GameState: new DropDownFieldDefinition('GRS Game State', 'The approval state of the game in GRS', GRS_APPROVAL_STATES),
                AdditionalState: new DropDownFieldDefinition('GRS Chill State', 'The approval state of the Chill in GRS', GRS_APPROVAL_STATES),
                CustomChillUrl: new TextFieldDefinition('Custom Chill URL'),
                CustomGameResourcesPath: new DropDownFieldDefinition('Custom Game Resources URL', '', [
                    {value: 'qa-games.images4us.com'}
                ]),
                GameTechnology: new DropDownFieldDefinition('Game Technology', '', [
                    {value: 'html5'},
                    {value: 'flash'}
                ])
            }
        },
        TripleEight: {
            useGameLauncher: new BooleanFieldDefinition('Use Game Launcher'),
            gameLauncherUrl: new TextFieldDefinition('Game Launcher URL'),
            isUsingGGPMock: new BooleanFieldDefinition('Is using GGP Mock Compatible')
        },
    });
}